import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'

export const useFeaturesTrads = () => {
	const { t } = useLingui()

	return useMemo(
		() =>
			({
				air_conditioning: () => t`Climatisation`,
				bike_parking: () => t`Parking à vélo`,
				coffee: () => t`Thé & café`,
				disabled_access: () => t`Accessibilité`,
				elevator: () => t`Ascenseur`,
				ergonomic_seating: () => t`Siège ergonomique`,
				external_screen: () => t`Écran externe`,
				hdmi_adapter: () => t`HDMI`,
				kitchen: () => t`Cuisine`,
				meeting_room: () => t`Salle de réunion`,
				microwave_oven: () => t`Micro-ondes`,
				paperboard: () => t`Paperboard`,
				pets_welcomed: () => t`Animaux acceptés`,
				phone_box: () => t`Phone box`,
				printer: () => t`Imprimante`,
				refrigerator: () => t`Réfrigérateur`,
				restroom: () => t`Toilettes`,
				scanner: () => t`Scanner`,
				shower: () => t`Douche`,
				snacks: () => t`Snacks`,
				sound_system: () => t`Sono`,
				standing_desk: () => t`Bureau debout`,
				terrace: () => t`Terrasse`,
				tv: () => t`Écran TV`,
				video_conferencing: () => t`Visioconférence`,
				video_projector: () => t`Vidéo-projecteur`,
				water: () => t`Fontaine à eau`,
				whiteboard: () => t`Tableau blanc`,
				wifi: () => t`Wifi sécurisé`,
			}) as Record<string, () => string>,
		[t],
	)
}
